<template>
  <FormsFieldsWrapper
    :name="name"
    inline
    :error="{ message: errorMessage }"
    :success="{
      valid: meta.valid,
      message: successMessage,
    }"
    class="flex items-center"
  >
    <RadioButton
      :name="name"
      :input-id="inputId"
      :model-value="inputValue"
      :value="value"
      :disabled="disabled"
      :class="{ 'p-invalid': errorMessage }"
      @change="handleChange"
      @blur="handleBlur"
    />
    <div
      v-if="label"
      class="pl-2"
    >
      <label
        :for="inputId"
        class="font-medium"
        :class="{
          'p-disabled': disabled,
          'cursor-pointer': !disabled,
        }"
      >
        <span>{{ label }}</span>
      </label>
      <p
        v-if="subLabel"
        class="mb-0 text-sm"
      >
        {{ subLabel }}
      </p>
    </div>
  </FormsFieldsWrapper>
</template>

<script setup lang="ts">
import useFormField, { defaultProps } from './useFormField'

const props = defineProps({
  ...defaultProps,
  value: {
    type: String,
    required: true,
  },
  inputId: {
    type: String,
    required: true,
  },
  subLabel: {
    type: String,
    required: true,
  },
})

const { name, inputValue, errorMessage, handleBlur, handleChange, meta }
  = useFormField(props)
</script>
